export const PFAS_CAMPAIGN_TYPE = 'pfas-drinking-water'
export const PFAS_CAMPAIGN_NAME = 'PFAS Drinking Water'

